// Colours per highway class, shared by the LM basemap's road-area and lane
// road-class views (`meta_temp_surface_road_class`) and the RM basemap's road-class
// view (`highway=`), so an area, its lanes and the RM road read as the same class.
//
// Saturated, one clearly different hue per class, ordered warm (major) to cool
// (minor). Deliberately NOT the OSM-carto road colours: the default background is
// OSM, so a carto-coloured road drawn over it — translucent especially — vanishes
// into the road it sits on. A `_link` takes its parent class's colour. Anything not
// listed (or missing) is UNKNOWN_ROAD_CLASS_COLOR, so an unexpected value stays
// visible instead of disappearing.
const ROAD_CLASS_COLORS = {
  motorway: "#c62828",
  trunk: "#ef6c00",
  primary: "#f9a825",
  secondary: "#7cb342",
  tertiary: "#00897b",
  residential: "#1e88e5",
  unclassified: "#1e88e5",
  living_street: "#1e88e5",
  service: "#5e35b1",
  // The rest of the Orbis spec's Minor Road Line group (see roadClass.js), which
  // the RM network is full of: brown for tracks, blue-grey for the non-motorised
  // ways, so they don't all land on the unknown magenta.
  track: "#6d4c41",
  road: "#6d4c41",
  pedestrian: "#78909c",
  footway: "#78909c",
  cycleway: "#78909c",
  path: "#78909c",
  steps: "#78909c",
  bridleway: "#78909c",
};
export const UNKNOWN_ROAD_CLASS_COLOR = "#d81b60";

export function roadClassColor(roadClass) {
  return (
    ROAD_CLASS_COLORS[roadClass?.replace(/_link$/, "")] ??
    UNKNOWN_ROAD_CLASS_COLOR
  );
}

export function withAlpha(hex, alpha) {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${n >> 16}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
}
